// extracted by mini-css-extract-plugin
export default {"block-text":"n7YAH4Am6_Yz_xx","block-title":"hdz4IYTIBSTRhdX","block":"JOqQofUndoc2XIJ"};